module.exports = __webpack_public_path__ + "static/media/verizon-logo.5986cd66.svg";